import { LEGEND_PLACEMENT_PRIORITY } from "./constants";
import { getCandidateRegion } from "./getCandidateRegion";
import type { FindLegendPlacement } from "./types";

export const findLegendPlacement: FindLegendPlacement = ({
  pageWidth,
  pageHeight,
  bbox,
  legendWidth,
  legendHeight,
  margin,
}) => {
  if (!bbox) {
    return {
      x: pageWidth - legendWidth - margin,
      y: pageHeight - legendHeight - margin,
      fitsOutside: true,
    };
  }

  for (const side of LEGEND_PLACEMENT_PRIORITY) {
    const region = getCandidateRegion({
      side,
      pageWidth,
      pageHeight,
      bbox,
      margin,
      legendWidth,
      legendHeight,
    });
    if (
      region.regionWidth >= legendWidth &&
      region.regionHeight >= legendHeight
    ) {
      return { x: region.x, y: region.y, fitsOutside: true };
    }
  }

  return {
    x: pageWidth - legendWidth - margin,
    y: pageHeight - legendHeight - margin,
    fitsOutside: false,
  };
};
